function formatNumber (number, locale) {
  if (number) {
    return (new Intl.NumberFormat(locale)).format(number)
  }

  return number
}

function formatSeconds (duration, { showHours = false, showSeconds = true } = {}) {
  const hours = showHours ? parseInt(duration / 3600) : 0

  if (showHours) {
    duration -= 3600 * hours
  }

  const minutes = parseInt(duration / 60, 10)
  const seconds = parseInt(duration % 60, 10)

  const parts = [
    showHours && ('0' + hours).slice(-2),
    ('0' + minutes).slice(-2),
    showSeconds && ('0' + seconds).slice(-2)
  ]

  return parts.filter(value => typeof value === 'string').join(':')
}

export {
  formatNumber,
  formatSeconds
}
